import { MapToContext } from '@utils/objectWithDefault'
import PerItemFee from './perItemFee'
import StorageFee from './storageFee'
import WroReceivedFee from './wroReceivedFee'

export default class DefaultRates {
  constructor (a) {
    const defaultDataModel = {
      wroReceivedFeeConfiguration: { val: [], type: WroReceivedFee },
      storageFeeConfiguration: { val: [], type: StorageFee },
      perItemFeeConfiguration: { val: [], type: PerItemFee }
    }
    MapToContext(this, defaultDataModel, a)
  }
}
